import { Flow } from "./entities";

const flow1: Flow = {
	name: "home.message.flow1",
	steps: [
		{ number: -5, component: "Profile" },
		{ number: -4, component: "ChangePassword" },
		{ number: -3, component: "RecoverPassword" },
		{ number: -2, component: "Register" },
		{ number: -1, component: "LoginFromProfile" },
		{ number: 0, component: "Home" },
		{ number: 1, component: "FindTable" },
		{ number: 2, component: "Login" },
		{ number: 3, component: "Details" },
	],
};

const flow2: Flow = {
	name: "home.message.flow2",
	steps: [
		{ number: -5, component: "Profile" },
		{ number: -4, component: "ChangePassword" },
		{ number: -3, component: "RecoverPassword" },
		{ number: -2, component: "Register" },
		{ number: -1, component: "LoginFromProfile" },
		{ number: 0, component: "Home" },
		{ number: 1, component: "ChooseService" },
		{ number: 2, component: "FindTable" },
		{ number: 3, component: "Login" },
		{ number: 4, component: "Details" },
	],
};

export const flows: Flow[] = [flow1, flow2];
